<template>
  <button
    v-quick-title="disabled ? '' : title"
    class="text-field-menu-item"
    :class="elClasses"
    :title="title"
    @click="action"
    @mousedown="onMouseDown"
  >
    <svg class="remix" >
      <use :xlink:href="require('remixicon/fonts/remixicon.symbol.svg') + `#ri-${icon}`" />
    </svg>
  </button>
</template>

<script>
/**
 * Item in the menu bar of a TipTap text field.
 * Taken from https://www.tiptap.dev/examples/collaborative-editing
 * @vue-prop {String} icon - Icon used for the item
 * @vue-prop {String} title - Title of the menu item
 * @vue-prop {Function} action - Function to trigger onclick
 * @vue-prop {Function} isActive - Function used to check if a menu item is in active state
 */

export default {

  name: 'TextFieldMenuItem',

  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    action: {
      type: Function,
      required: true,
    },
    isActive: {
      type: Function,
      default: null,
    },
    disabled: Boolean,
  },

  computed: {
    elClasses() {
      return {
        'text-field-menu-item--disabled': this.disabled,
        'is-active': this.isActive ? this.isActive(): undefined,
      };
    },
  },

  methods: {
    onMouseDown() {
      this.$emit('mousedown');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.text-field-menu-item {
  width: 1.75rem;
  height: 1.75rem;
  color: $color-main-text-dark;
  border: none;
  background-color: transparent;
  border-radius: 0.4rem;
  padding: 0.25rem;
  margin-right: 0.1rem;

  svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
  }

  &.is-active,
  &:not(.text-field-menu-item--disabled):hover {
    background-color: #ddd;
  }
}
</style>
